import { FieldArray } from 'formik';
import React from 'react';
import PropTypes from 'prop-types';
import { FormGroup, Label, Col } from 'reactstrap';

const FieldArrayItem = (props) => {
   return (
      <FormGroup className='row'>
         <Label
            for={props.name}
            sm={2}
         >
            { props.label }
         </Label>
         <Col sm={6}>
            <FieldArray
               {
                  ...props
               }
            />
         </Col>
      </FormGroup>
   );
};

FieldArrayItem.propTypes = {
   label: PropTypes.string.isRequired,
   name: PropTypes.string.isRequired,
   component: PropTypes.func.isRequired,
   options: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
   })),
};

FieldArrayItem.defaultProps = {
   options: undefined,
};


export default FieldArrayItem;
